/**
 * Warning before a RESTRICTED bid is saved to the library.
 *
 * Submission harvest copies the bid's final response into the org-wide
 * library, where every member and their AI can read it, and the outcome is
 * stamped onto it later. For a restricted bid that widens who can see it, so
 * both harvest paths (Mark as Submitted, and the overview's late "Add
 * submission to library") stop here first. Cancel sends nothing.
 *
 * Driven by `useHarvestStore.restrictedWarning`; mounted once in AppLayout.
 */

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { useHarvestStore } from '@/stores/harvest-store'
import { RESTRICTED_HARVEST_COPY } from '@/components/harvest/restricted-harvest-copy'

export function RestrictedHarvestWarningDialog() {
  const warning = useHarvestStore((s) => s.restrictedWarning)
  const confirmRestrictedHarvest = useHarvestStore((s) => s.confirmRestrictedHarvest)
  const cancelRestrictedHarvest = useHarvestStore((s) => s.cancelRestrictedHarvest)

  return (
    <AlertDialog
      open={warning !== null}
      onOpenChange={(open) => {
        if (!open) cancelRestrictedHarvest()
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{RESTRICTED_HARVEST_COPY.title}</AlertDialogTitle>
          <AlertDialogDescription>{RESTRICTED_HARVEST_COPY.body}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{RESTRICTED_HARVEST_COPY.cancel}</AlertDialogCancel>
          <AlertDialogAction onClick={() => void confirmRestrictedHarvest()}>
            {RESTRICTED_HARVEST_COPY.confirm}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
